import { useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import { credits } from "./creditsData";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <Link to="/" className="logo" onClick={closeMenu}>
        Alec Lindsell
      </Link>

      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        Menu
      </button>

      <nav className={menuOpen ? "open" : ""}>
        <Link to="/work" onClick={closeMenu}>Work</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/credits" onClick={closeMenu}>Credits</Link>
        <Link to="/reel" onClick={closeMenu}>Reel</Link>
        <Link to="/contact" onClick={closeMenu}>Contact</Link>
      </nav>
    </header>
  );
}

function Home() {
  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <p className="eyebrow">
  Series Director · <span className="no-break">Shooting PD</span> · Edit Producer
</p>

          <h1>Alec Lindsell</h1>

          <p className="role">
            Premium factual, specialist factual, factual-entertainment, observational documentary and branded content.
          </p>

          <p className="intro">
            Expert visual storytelling for broadcast, streaming and
            international documentary series.
          </p>

          <div className="hero-buttons">
  <Link to="/work">View Work</Link>

  <Link to="/reel" className="secondary">
    Watch Reel
  </Link>
</div>
        </div>
      </section>


    </>
  );
}

function Work() {
  const [activeVideo, setActiveVideo] = useState(null);
const [activeVideoInfo, setActiveVideoInfo] = useState(null);
  const workAreas = [
    {
      title: "True Crime",
      role: "Series Director · Shooting Producer / Director / Edit Producer",
      image: "/images/work-truecrime02.jpg",
      text: "Crime documentaries built around key testimony, interviews of a sensitive nature, reconstruction, archive, evidence, and careful editorial structure.",
      videoUrl: "https://player.vimeo.com/video/1114247333?h=947e56de4a",
        videoInfo: {
    intro:
      "Excerpts from some of Alec's true crime projects which he has filmed and directed.",
    chapters: [
      "00:26 - Murder in Mind: Kill for Thrill",
      "02:46 - Murder in Mind: A Valentine's Trip",
      "05:07 - Killers Caught on Camera Season 3: La Madera Murders",
      "07:25 - Bodycam: William Jones",
      "09:37 - Wartime Crime: Blackout Killers",
    ],
  },
},
    {
      title: "History & Heritage",
      role: "Producer / Director · Edit Producer",
      image: "/images/work-tower01.jpg",
      text: "Access-led history and heritage projects shaped through expert contributors, colourful characters, stunning locations and behind-the-scenes observational content.",
    },
    {
      title: "Premium Documentary",
      role: "Producer / Director",
      image: "/images/work-bermuda03.jpg",
      text: "Expert factual storytelling with strong structure, tone and visual identity, ranging from feature-length documentaries to multi-part series across a wide range of subjects and themes.",
    },
    {
      title: "Observational & Access",
      role: "Shooting Producer / Director",
      image: "/images/work-charles.jpeg",
      text: "Contributor-led scenes, sensitive access, actuality and unfolding human stories.",
    },
    {
      title: "Specialist Factual",
      role: "Shooting Producer / Director · Edit Producer",
      image: "/images/work-factory.jpg",
      text: "Clear, visual storytelling featuring, engineering, science, history and explaining complex processes.",
    },
    {
      title: "Archive & Music Documentary",
      role: "Producer / Director · Editor",
      image: "/images/work-bradpitt.jpg",
      text: "In-depth profile, archive and talking-head cultural documentaries shaped through testimony, clips and authored narratives.",
    },
  ];

  return (
    <section className="section work-section page-section">
      <div className="section-heading">
  <p className="eyebrow">Selected Work</p>
  <h2>Story, access, archive and visual documentary craft.</h2>
  <p className="section-intro">
    From true crime and
    archive-led documentaries to history, specialist factual and access-driven
    observational films.
  </p>
</div>

      <div className="work-grid">
        {workAreas.map((item) => (
          <article className="work-card" key={item.title}>
            <div
              className="work-image"
              style={{ backgroundImage: `url('${item.image}')` }}
            ></div>

            <div className="work-card-content">
              <p>{item.role}</p>
              <h3>{item.title}</h3>
              <span>{item.text}</span>
              {item.videoUrl && (
  <button
    className="work-video-button"
    onClick={() => {
  setActiveVideo(item.videoUrl);
  setActiveVideoInfo(item.videoInfo || null);
}}
  >
    Watch Reel
  </button>
)}
            </div>
          </article>
        ))}
      </div>
      {activeVideo && (
  <div
    className="video-modal"
    onClick={() => {
      setActiveVideo(null);
      setActiveVideoInfo(null);
    }}
  >
    <div className="video-modal-inner" onClick={(e) => e.stopPropagation()}>
      <button className="video-modal-close" onClick={() => setActiveVideo(null)}>
        Close
      </button>

      <iframe
        src={activeVideo}
        title="Selected Work Reel"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>

      {activeVideoInfo && (
  <div className="video-modal-info">
    <p>{activeVideoInfo.intro}</p>

    <ul>
      {activeVideoInfo.chapters.map((chapter) => (
        <li key={chapter}>{chapter}</li>
      ))}
    </ul>
  </div>
)}
    </div>
  </div>
)}
    </section>
  );
}

function About() {
  return (
    <section className="section about-section page-section">
      <div
  className="about-hero-image about-hero-overlay"
  style={{ backgroundImage: "url('/images/work-rikshaw.jpg')" }}
>
  <div className="about-hero-copy">
    <p className="eyebrow">About</p>
    <h2>Calm, story-focused direction for engaging factual television.</h2>
    <p>
      Alec works across development, filming and post-production, shaping
      complex stories from initial concept through to final delivery.
    </p>
  </div>
</div>

<div className="about-copy about-copy-centred">
  <p>
    A UK-based documentary filmmaker Alec has over 20 years’ experience
    across factual television, specialist factual, feature-length documentary,
    VTs and observational documentary.
  </p>

  <p>
    His background in editing and edit producing gives him a strong instinct
    for structure, pace and emotional clarity, while nearly two decades as a
    shooting director and producer have given him the ability to capture
    high-quality, purposeful and story-led material on location and in studio
    environments.
  </p>

  <p>
    A film fanatic from an early age, Alec is drawn to stories of all scales
    and subjects. He believes every story has a way in, a route to clarity,
    tension and emotion that allows the audience to connect. Whether behind the
    camera or in the edit, he works confidently and collaboratively with crew,
    contributors and production teams to bring those stories to life.
  </p>
</div>

      <div className="approach-grid">
        <div>
          <h3>Story</h3>
          <p>Narrative structure,  testimony, archive, actuality and scripted links</p>
        </div>

        <div>
          <h3>Access</h3>
          <p>Working with sensitive contributors, duty of care, trusted behind the scenes of major establishments.</p>
        </div>

        <div>
          <h3>Shooting</h3>
          <p>Self-shooting to a high broadcast standard with visual flair, technical expertise.</p>
        </div>

        <div>
          <h3>Post</h3>
          <p>Edit producing, scripting, writing voiceover and working with commissioner notes.</p>
        </div>
      </div>
      <div className="about-image-row">
  <div
    className="about-small-image"
    style={{ backgroundImage: "url('/images/work-rikshaw02.jpg')" }}
  ></div>

  <div
    className="about-small-image"
    style={{ backgroundImage: "url('/images/work-selfie01.jpg')" }}
  ></div>
</div>
    </section>
  );
}

function Credits() {
  return (
    <section className="section credits-section page-section">
      <div className="section-heading">
        <p className="eyebrow">Credits</p>
        <h2>Broadcast credits.</h2>
      </div>

      <div className="credits-card-list">
        {credits.map((credit, index) => (
          <article className="credit-card" key={`${credit.title}-${index}`}>
            <div
              className="credit-card-image"
              style={{
                backgroundImage: credit.image
                  ? `url('${credit.image}')`
                  : "linear-gradient(135deg, #252525, #111)",
              }}
            ></div>

            <div className="credit-card-content">
              <p className="credit-meta">
                {credit.role} · {credit.channel} · {credit.company}
              </p>

              <h3>{credit.title}</h3>

              <p className="credit-date">{credit.date}</p>

              {credit.synopsis && (
                <p className="credit-synopsis">{credit.synopsis}</p>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function Reel() {
  return (
    <section className="section reel-section page-section">
      <div className="section-heading">
        <p className="eyebrow">Showreel</p>

      </div>

      <div className="reel-video">
        <iframe
          src="https://player.vimeo.com/video/876294855"
          title="Alec Lindsell Showreel"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
}

function Contact() {
  return (
    <section className="contact-hero page-section">
      <div className="contact-hero-content">
        <p className="eyebrow">Contact</p>

        <div className="contact-details">
          <a href="mailto:alec.lindsell@gmail.com">
            <span className="contact-icon">✉</span>
            alec.lindsell@gmail.com
          </a>

          <a href="tel:+447974735856">
            <span className="contact-icon">☏</span>
            +44 7974 735 856
          </a>
        </div>
        <div className="membership-block">
  <p>Member of</p>

  <div className="membership-logos">
    <img src="/images/Directors-UK-logo.png" alt="Directors UK" />
    <img src="/images/Bectu_Logo.png" alt="Bectu" />
  </div>
</div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <p>© {new Date().getFullYear()} Alec Lindsell</p>

      <div className="footer-links">
        <a href="mailto:alec.lindsell@gmail.com">Email</a>
        <a href="tel:+447974735856">Phone</a>

        <a
          href="https://www.linkedin.com/in/alec-lindsell-ab3226b/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
          className="footer-icon-link"
        >
          <span className="footer-icon">in</span>
        </a>

        <a
          href="https://www.thetalentmanager.com/talent/5471/alec-lindsell"
          target="_blank"
          rel="noreferrer"
          aria-label="Talent Manager"
          className="footer-icon-link"
        >
          <span className="footer-icon">TM</span>
        </a>
      </div>
    </footer>
  );
}

function App() {
  return (
    <BrowserRouter>
      <main>
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/reel" element={<Reel />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />  
      </main>
    </BrowserRouter>
  );
}

export default App;